var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxOpenLongTime({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 0.666504H0V5.24984H0.00833352L0 5.25817L3.74167 8.99984L0 12.7415L0.00833352 12.7498H0V17.3332H10V12.7498H9.99167L10 12.7415L6.25833 8.99984L10 5.25817L9.99167 5.24984H10V0.666504H8.33333Z",
    fill: "#14AC63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxOpenLongTime);
export default __webpack_public_path__ + "static/media/BoxOpenLongTime.6bc3253626e478f9cfb33db87c137c43.svg";
export { ForwardRef as ReactComponent };